import { defaultMwsState } from './module-mws-state';

export default {
	resetState(state) {
		Object.assign(state, defaultMwsState);
	},
	/**
	 * Cache token MWS sau khi gọi GET api/mws/token
	 * payload: { ExpiredDate: epoch ms, Token: MWSTokenResponse }
	 */
	updateMWSToken(state, payload) {
		state.MWSToken = payload;
	}
};
